<template>
  <header
    id="m_header"
    class="m-grid__item m-header d-block d-print-none"
    m-minimize-offset="200"
    m-minimize-mobile-offset="200"
  >
    <div class="m-container m-container--fluid m-container--full-height">
      <div class="m-stack m-stack--ver m-stack--desktop">
        <!-- BEGIN: Brand -->
        <div class="m-stack__item m-brand m-brand--skin-light ">
          <div class="m-stack m-stack--ver m-stack--general">
            <div class="m-stack__item m-stack__item--left m-stack__item--middle m-brand__tools">
              <!-- BEGIN: Left Aside Minimize Toggle -->
              <a
                href="javascript:;"
                id="m_aside_left_minimize_toggle"
                class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block "
                ><span></span
              ></a>
            </div>
            <div class="m-stack__item m-stack__item--middle m-brand__logo">
              <a href="/" class="m-brand__logo-wrapper">
                <img
                  alt="Griffin"
                  src="@/assets/media/img/logo/logo_griffin.svg"
                  height="40"
                  style="margin:15px 15px 10px 0;"
                />
              </a>
            </div>
            <div class="m-stack__item m-stack__item--middle m-brand__tools">
              <!-- BEGIN: Left Aside Minimize Toggle -->
              <!-- <a href="javascript:;" id="m_aside_left_minimize_toggle" class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block "><span></span></a> -->
              <!-- END -->
              <!-- BEGIN: Responsive Aside Left Menu Toggler -->
              <a
                href="javascript:;"
                id="m_aside_left_offcanvas_toggle"
                class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block"
                ><span></span
              ></a>
              <!-- END -->
              <!-- BEGIN: Responsive Header Menu Toggler
                        <a id="m_aside_header_menu_mobile_toggle" href="javascript:;" class="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block"><span></span></a>
                        -->
              <!-- END -->
              <!-- BEGIN: Topbar Toggler -->
              <a
                id="m_aside_header_topbar_mobile_toggle"
                href="javascript:;"
                class="m-brand__icon m--visible-tablet-and-mobile-inline-block"
                ><i class="flaticon-more"></i
              ></a>
              <!-- BEGIN: Topbar Toggler -->
            </div>
          </div>
        </div>
        <!-- END: Brand -->
        <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
          <!-- BEGIN: Horizontal Menu -->
          <button
            class="m-aside-header-menu-mobile-close m-aside-header-menu-mobile-close--skin-dark "
            id="m_aside_header_menu_mobile_close_btn"
          >
            <i class="la la-close"></i>
          </button>
          <!--
                <div id="m_header_menu" class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark " >
                    <ul class="m-menu__nav">
                        <li class="m-menu__item m-menu__item--submenu m-menu__item--rel" aria-haspopup="true">
                            <a href="#" class="m-menu__link" title="Nova fatura avulsa"><span class="m-menu__link-text"><i class="fas fa-plus-square"></i> Fatura Avulsa</span></a>
                        </li>
                        <li class="m-menu__item m-menu__item--submenu m-menu__item--rel" aria-haspopup="true">
                            <a href="#" class="m-menu__link" title="Gerar fatura mensal"><span class="m-menu__link-text"><i class="fas fa-cogs"></i> Gerar Faturas</span></a>
                        </li>
                    </ul>
                </div>
                -->
          <!-- END: Horizontal Menu -->
          <!-- BEGIN: Topbar -->
          <div id="m_header_topbar" class="m-topbar m-stack m-stack--ver m-stack--general">
            <div class="m-stack__item m-topbar__nav-wrapper">
              <ul class="m-topbar__nav m-nav m-nav--inline">
                <StatusContaAzul v-if="user" />
                <UserDropdown v-if="user" />
              </ul>
            </div>
          </div>
          <!-- END: Topbar -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import UserDropdown from '@/components/template/header/UserDropdown';
import StatusContaAzul from '@/components/template/header/StatusContaAzul';

export default {
  name: 'Header',
  components: { UserDropdown, StatusContaAzul },
  data() {
    return {};
  },
  computed: mapState(['user']),
};
</script>

<style></style>
